module.exports = __webpack_public_path__ + "img/vyberte_byt.4c81d14c.svg";